import SelectorComponent from '@/components/commons/selector/SelectorComponent.vue'
import { thingService } from '@/services/thing.service'
import { enterpriseService } from '@/services/enterprise.service'
import { currentStateService } from '@/services/current-state.service'
import i18n from '@/i18n'
import { clone } from 'ramda'
import { SelectorModel } from '@/constants/constants'
import { currentStateApi } from '../../api/current-state.api';
import { filterRulesMapped } from '../../tools/filterRules'
import { dateSortFunction } from '../../tools/functions'
import {geoReferenceApi, cancelGeoData} from '../../api/geoReference.api'

const REFRESH_INTERVAL = 2; // minutos

export default {
  name: 'CurrentStateComponent',
  components: {
  SelectorComponent,
  },

   data: () => ({
      tableHeaders: [],
      tableFilterRules: {},
      tableData: [],
      tableDataKey: '_id',
      tableComponentButtons: [],
      queryPageSize: 100,
      queryPageNumber: 1,
      pageTotal: undefined,
      loadingTable: false,
      maxRadius: 20,
      ubicationResolved: false,
      geoDataIndex: -1,
      requestCountGeoData: 0,
      rowActions: [
        {
          id: 1,
          name: i18n.t('poi.create'),
          color: 'blue',
          icon: 'push_pin',
        },
      ],
      //configuracion de la tabla
      tableConfiguration: {},
      // selector
      showSelector: false,
      showTable: true,
      selectorModel: clone(SelectorModel),
      // ids filtrados por selector
      queryThingIds: [],
      // cursor-based pagination
      queryCursor: null,
      nextCursor: null,
      hasMore: false,
      cursorHistory: {},
      intervalId: null,
    }),

    created() {
      this.$_debounceTimeoutId = null;
        this.selectorModel.filters.push({
            id: 'enterprises',
            name: i18n.t('enterprise.name'),
            show: false,
            disabled: false,
            data: [],
            selectedData: [],
            singleSelect: false,
        })
        this.selectorModel.filters.push({
            id: 'things',
            name: i18n.t('equipment.name'),
            show: false,
            disabled: false,
            data: [],
            selectedData: [],
            singleSelect: false,
        })

        this.tableComponentButtons.push({
          id: 'get-geo-data',
          tooltip: i18n.t('currentState.loadUbications'),
          icon: 'explore',
          action: this.fireGeoDataRequests.bind(this),
          selectedData: false,
        });
            // no usamos selector de fecha/hora en este reporte
        this.selectorModel.showDateAndTimeSelector = false
       
    },

    mounted() {
      this.$vuetify.lang.current = this.$i18n.locale;
    //  this.initializeSelector();
      this.loadingTable = true;
      this.getReportData(true) 
    },

    beforeDestroy() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      } 
        // Cancelar las request pendientes
      if (this.requestCountGeoData > 0) {
        cancelGeoData('cancel geo-data requests');
      }

      clearTimeout(this.$_debounceTimeoutId);
      this.$_debounceTimeoutId = null;
    },

    methods: {
        async initializeSelector(){
            try {
                const enterprisesRaw = await enterpriseService.getAllForSelector()
                const enterprises = (enterprisesRaw || []).map((e) => ({ id: e._id || e.id, name: e.name }))
                if (this.selectorModel.filters && this.selectorModel.filters.length > 0) {
                    try {
                        if (this.selectorModel.filters[0].data && typeof this.selectorModel.filters[0].data.cleanAndUpdate === 'function') {
                        this.selectorModel.filters[0].data.cleanAndUpdate(enterprises)
                        } else {
                        // fallback: asignar directamente
                        this.selectorModel.filters[0].data = enterprises
                        }
                    } catch (e) {
                        console.debug('Error updating selector enterprises:', e)
                        this.selectorModel.filters[0].data = enterprises
                    }
                    console.debug('Loaded enterprises for selector:', enterprises)
                    }
                    // watch for changes in selected enterprises to load related things
                this.$watch(
                    () => (this.selectorModel && this.selectorModel.filters && this.selectorModel.filters[0] ? this.selectorModel.filters[0].selectedData : []),
                    (newVal) => {
                        try {
                        const enterpriseIds = (newVal || []).map((e) => e.id || e._id)
                        this.loadThingsForEnterprises(enterpriseIds)
                        } catch (e) {
                        // ignore
                        }
                    },
                    { deep: true },
                )
            } catch (e) {
                console.error(e)
            }

        },
//-----------------------------------UBICACIONES-----------------------------------
        fireGeoDataRequests() {
          const header = this.tableHeaders.find((h) => h.value === 'ubication');
            if (header) {
              header.spinner = true;
              header.cellConfig = { spinnerColor: '#03A9F4' };
              header.selected = true;
            }
            this.getGeoData();
            this.ubicationResolved = true;
        },

        getGeoData() {
          this.geoDataIndex++;
          if (this.geoDataIndex < this.tableData.length) {
            if (!this.tableData[this.geoDataIndex].ubication) {
              this.geoRequest(this.tableData[this.geoDataIndex], this.geoDataIndex);
            } else {
              this.getGeoData();
            }
          }
        },

        geoRequest(data, index) {
          this.requestCountGeoData++;
          if (this.requestCountGeoData < 10) {
            this.getGeoData();
          }
          geoReferenceApi
            .getGeoData(data.lat, data.long, this.maxRadius)
            .then((response) => {
              this.requestCountGeoData--;
              if (this.requestCountGeoData < 10) {
                this.getGeoData();
              }
              const updatedItem = this.tableData[index];
              updatedItem.ubication =
                response.data.geoLocationData.title + ' - ' + response.data.geoLocationData.subtitle;
              this.tableData.splice(index, 1, updatedItem);
              this.updateUbicationHeaderState();
            })
            .catch(() => {
              this.requestCountGeoData--;
              if (this.requestCountGeoData < 10) {
                this.getGeoData();
              }
              this.updateUbicationHeaderState();
            });
        },

        updateUbicationHeaderState() {
          const ubHeader = (this.tableHeaders || []).find((h) => h.value === 'ubication')
          if (!ubHeader) return
          const missing = (this.tableData || []).filter((r) => !r || !r.ubication).length
          if (this.ubicationResolved && (this.requestCountGeoData > 0 || missing > 0)) {
            ubHeader.spinner = true
            ubHeader.selected = true
          } else {
            ubHeader.spinner = false
            ubHeader.selected = false
          }
        },
//---------------------------------------------------------------------------------------------------------
        async loadThingsForEnterprises(enterpriseIds) {
              try {
                if (!enterpriseIds || enterpriseIds.length === 0) {
                  // limpiar
                  if (this.selectorModel.filters[1]) {
                    this.selectorModel.filters[1].data.cleanAndUpdate([])
                    this.selectorModel.filters[1].selectedData = []
                  }
                  return
                }
                const raw = await thingService.getAllNestedByEnterprise(enterpriseIds)
                const normalized = this.normalizeItems(raw || [])
                if (this.selectorModel.filters[1]) {
                  this.selectorModel.filters[1].data.cleanAndUpdate(normalized)
                  this.selectorModel.filters[1].selectedData = []
                }
              } catch (e) {
                console.error(e)
              }
        },
        
        normalizeItems(items) {
            const lang = localStorage.getItem('locale') || 'es'
            const normalize = (list) => {
                return list.map((it) => {
                  const id = it._id || it.id || it.value || (it.key && it.key.toString())
                  let name = ''
                  if (typeof it.name === 'object') {
                    name = it.name[lang] || it.name.en || it.name.es || it.name.pt || ''
                  } else {
                    name = it.name || it.label || it.text || ''
                  }
                  const children = []
                  if (it.children && Array.isArray(it.children) && it.children.length > 0) {
                    children.push(...normalize(it.children))
                  }
                  // some endpoints return 'things' or 'items' arrays
                  if (it.things && Array.isArray(it.things) && it.things.length > 0) {
                    children.push(...normalize(it.things))
                  }
                  return { id, name, children }
                })
              }
              return normalize(items)
        },

        onServerFilter(payload) {
        // payload.filters tiene keys = header.value
        //const nameFilter = payload.filters.name; // si el header.value es 'name'
        console.log('onServerFilter called with filters:', payload);
        // llamar API con payload.filters, payload.pageSize, payload.pageNumber
      },

        setTableFilterRules() {
          this.tableFilterRules = {};
          this.tableHeaders.forEach((header) => {
            this.tableFilterRules[header.value] = filterRulesMapped[header.filterType];
          });
        },

         setSortFunctions() {
          /*
          Para ordenar las columnas fecha y hora
          TO DO: analizar la posibilidad de incluir este tipo de sorting en el componente genérico
          */
          this.tableHeaders.find((header) => header.value === 'positionTimestamp').sort = (a, b) => {
            return dateSortFunction(a, b, 'DD/MM/YYYY HH:mm:ss');
          };
          this.tableHeaders.find((header) => header.value === 'comunicationTimestamp').sort = (
            a,
            b,
          ) => {
            return dateSortFunction(a, b, 'DD/MM/YYYY HH:mm:ss');
          };
        },

        selector() {
          this.showSelector = !this.showSelector
        },

        //ESTO ES PARA EL SELECTOR
        /*async getReport(eventData) { 
          this.showSelector = false
          this.loadingTable = true

          // obtener ids de equipos seleccionados
          this.queryThingIds = []
          const enterpriseFilter = eventData && eventData.filters ? eventData.filters.find((f) => f.id === 'enterprises') : null
          const thingFilter = eventData && eventData.filters ? eventData.filters.find((f) => f.id === 'things') : null

          const extractId = (item) => {
            if (!item && item !== 0) return null
            if (typeof item === 'string' || typeof item === 'number') return item
            return item.id || item._id || item.value || (item.key && item.key.toString()) || null
          }

          const collectLeafIds = (list, out) => {
            if (!list || !Array.isArray(list)) return
            list.forEach((node) => {
              if (node && node.children && node.children.length > 0) {
                collectLeafIds(node.children, out)
              } else {
                const id = extractId(node)
                if (id) out.push(id)
              }
            })
          }

          // si hay cosas seleccionadas, usarlas
          if (thingFilter && thingFilter.selectedData && thingFilter.selectedData.length > 0) {
            collectLeafIds(thingFilter.selectedData, this.queryThingIds)
          } else if (enterpriseFilter && enterpriseFilter.selectedData && enterpriseFilter.selectedData.length > 0) {
            // si no hay cosas seleccionadas pero hay empresas, obtengo todas las cosas de esas empresas
            const enterpriseIds = (enterpriseFilter.selectedData || []).map((e) => extractId(e)).filter(Boolean)
            try {
              const raw = await thingService.getAllNestedByEnterprise(enterpriseIds)
              const normalized = this.normalizeItems(raw || [])
              collectLeafIds(normalized, this.queryThingIds)
            } catch (e) {
              console.error(e)
            }
          }

          try {
            // reset cursor when applying new filters
            this.queryCursor = null
            this.nextCursor = null
            this.hasMore = false
            this.queryPageNumber = 1
            await this.getData(true)
          } catch (e) {
            console.error(e)
          }
        },*/

        refreshTable() {
          this.getData(false);
        },

        async getReportData(initAutoRefresh = false) {
          if (initAutoRefresh) {
            // initial load without refresh flag so headers come from backend
            await this.getData(false)
            clearInterval(this.intervalId);
            const that = this;
            this.intervalId = setInterval(
              async function () {
                // interval-triggered refresh should pass refresh=true to avoid overwriting local header state
                await that.getData(true);
              },
              REFRESH_INTERVAL * 60 * 1000,
            );
          } else {
            await this.getData(false);
          }

        },

        async getData(refresh=false) {         
          this.loadingTable = true
          try {
           const resp = await currentStateApi.getCurrentStateAll(
              //this.queryPageSize,
              //this.queryPageNumber,
              //this.queryThingIds,
              //this.queryCursor,
            )
              // also log at info level so it is visible when DevTools filters out verbose/debug
              if (resp && resp.data) {
                  this.queryCursor = resp.nextCursor || null
                    const processed = await currentStateService.processCurrentStateData(resp.data)
                    const { data, headers } = processed || {}
                    this.tableData.cleanAndUpdate(data)
                    if (!refresh) {
                      this.tableHeaders.cleanAndUpdate(headers);
                      this.setTableFilterRules();
                      this.setSortFunctions();
                    }

                  if (this.requestCountGeoData > 0) {
                    cancelGeoData('cancel geo-data requests');
                  }

                  this.geoDataIndex = -1;
                  this.maxRadius = 20;
                  this.requestCountGeoData = 0;

                   // limpiar el timeout
                  clearTimeout(this.$_debounceTimeoutId);
                  this.$_debounceTimeoutId = null;

                  // update header spinner state after resets
                  this.updateUbicationHeaderState();

                  if (this.ubicationResolved) {
                      this.fireGeoDataRequests();
                  }
                
                }
                this.loadingTable = false
          } catch (e) {
            console.error('Error fetching current state data:', e)
          }
        },
        //PARA PAGINADO CON CURSOR
      /*  async fetchPage(pageSize, pageNumber) {
          console.log('fetchPage called with pageNumber:', pageNumber, ' pageSize:', pageSize, ' currentCursor:', this.queryCursor)
        },*/

        validateSelector() {
          try {
            const filters = (this.selectorModel && this.selectorModel.filters) ? this.selectorModel.filters : []
            const enterpriseFilter = filters.find((f) => f.id === 'enterprises')
            const thingFilter = filters.find((f) => f.id === 'things')

            const hasSelectedThings = thingFilter && Array.isArray(thingFilter.selectedData) && thingFilter.selectedData.length > 0
            const hasSelectedEnterprises = enterpriseFilter && Array.isArray(enterpriseFilter.selectedData) && enterpriseFilter.selectedData.length > 0

            // enable save button if there are selected things or selected enterprises
            this.selectorModel.disableSaveButton = !(hasSelectedThings || hasSelectedEnterprises)
          } catch (e) {
            console.error('validateSelector error:', e)
          }
        },

      


    },

    watch: {
        'selectorModel.filters': {
        handler: function () {
            this.validateSelector()
        },
        deep: true,
        },

         requestCountGeoData() {
          const that = this;
          if (this.requestCountGeoData === 10 && that.geoDataIndex < that.tableData.length) {
            clearTimeout(that.$_debounceTimeoutId);
            that.$_debounceTimeoutId = null;
            that.$_debounceTimeoutId = setTimeout(() => {
              cancelGeoData('cancel geo-data requests');
              that.requestCountGeoData = 0;
              that.getGeoData();
            }, 60000);
          } else if (that.tableData.filter((a) => !a.ubication).length > 0) {
            clearTimeout(that.$_debounceTimeoutId);
            that.$_debounceTimeoutId = null;
            that.$_debounceTimeoutId = setTimeout(() => {
              cancelGeoData('cancel geo-data requests');
              that.geoDataIndex = -1;
              that.requestCountGeoData = 0;
              that.getGeoData();
            }, 60000);
          } else {
            clearTimeout(this.$_debounceTimeoutId);
            this.$_debounceTimeoutId = null;
          }
    },
      
    },



}